import { Component, OnInit } from '@angular/core';
import { StepsService } from '@shared/services/steps/steps.service';

@Component({
  selector: 'progress-ring',
  templateUrl: './progress-ring.component.html',
  styleUrls: ['./progress-ring.component.scss']
})
export class ProgressRingComponent implements OnInit {
  progressValue = 0;
  previousValue = this.progressValue;
  constructor(private _stepsService: StepsService) {}

  ngOnInit() {
    this._stepsService.updateProgressValue.subscribe(value => {
      this.previousValue = this.progressValue;
      this.progressValue = value;
      this.updateProgressFill(this.progressValue, this.previousValue);
    });
  }

  updateProgressFill(current, previous) {
    const cpw = document.querySelector('#circular-progress-wrapper')
      .firstElementChild;
    let svgString = cpw.innerHTML || '';
    svgString = svgString.replace(
      `stroke-dasharray="${previous}, 100"`,
      `stroke-dasharray="${current}, 100"`
    );
    cpw.innerHTML = svgString;
    cpw.querySelector('.percentage').innerHTML = `${current}%`;
  }
}
